import ModalManager from '../Modals/ModalManager';
import { TauriImage } from '@readcloud/fetch-wrapper';

type Props = {
  url: string;
};

const ImageViewer = (props: Props) => {
  return (
    <>
      <div className="rc-flex rc-justify-center rc-items-center rc-h-full rc-w-full">
        <TauriImage src={props.url} />
      </div>
      <ModalManager />
    </>
  );
};

export default ImageViewer;
